module.exports = __webpack_public_path__ + "media/abk/assets/images/avatar-placeholder-a86bacc03df0aa85d47fe4597066fd77.png";